

<template>
  <div class="home_measure_card" :style="{ position: isTip || !model ? 'relative' : 'unset' }">
    <!-- 背景图片 -->
    <img 
      v-if="!isTip" 
      class="bg-img static" 
      src="../../../assets/icon_dean_home_bg_card_5.png" 
      alt="" 
    />
    <img 
      v-if="isTip" 
      class="bg-img absolute" 
      src="../../../assets/icon_dean_home_bg_card_1_1.png" 
      alt="" 
    />

		<div class="empty-state-1" v-if="!model">
			<img 
				src="../../../assets/icon_dean_home_card_empty_icon_2.png" 
				alt="" 
			/>
			<div class="empty-text">{{ '暂无数据' || ' ' }}</div>
		</div>
    
    <!-- 主内容容器 -->
    <div class="main-container">
      <div class="content-wrapper" :style="{ pointerEvents: isTip ? 'none' : 'unset' }">
        <!-- 标题栏 -->
        <div class="header">
          <div class="title-group">
            <div class="title-tag"></div>
            <div class="title-text">当日测量情况</div>
            <div class="count-badge" :style="{ opacity: model ? 1 : 0 }" v-if="model">
              <img src="../../../assets/icon_common_special_arrow_15.png" alt="" />
              <div class="count-text">当日已测：{{ getTestedNum() }}/{{ getTotalNum() }}</div>
            </div>
          </div>
          
          <div class="header-actions" v-if="model && getTestedNum() > 0">
            <img src="../../../assets/icon_dean_home_bg_card_icon_1.png" alt="" />
            <div class="see-all" @click="seeAll">
              <span>查看全部</span>
              <img src="../../../assets/icon_dean_home_bg_card_icon_8.png" alt="" />
            </div>
          </div>
        </div>
        
        <!-- 数据内容区 -->
				<div class="data-content" v-if="model">
					<!-- 测量卡片：循环渲染（避免4个卡片重复代码，后续可直接通过data控制数量） -->
					<div class="measure-card" v-for="(card, index) in [1, 2, 3, 4]" :key="index">
						<!-- 卡片背景图（单独层级，避免遮挡内容） -->
						<img class="measure-card__bg" src="../../../assets/icon_dean_home_card_measure_1.png" alt="测量卡片背景" />
						
						<!-- 卡片标题栏（异常统计） -->
						<div class="measure-card__header" @click="clickCard(card, index)" :style="{ cursor: getTestedNum() > 0 ? 'pointer' : 'unset' }">
							<img class="measure-card__header-icon" :src="getMeasureCardsData(index).cIcon" alt="异常图标" />
							<span class="measure-card__header-text">{{ getMeasureCardsData(index).cTitle }}</span>
							<!-- 数字统计（拆分正常/异常色） -->
							<span class="measure-card__count-normal">{{ getMeasureCardsData(index).cNum }}</span>
							<span v-if="getMeasureCardsData(index).cNum && getMeasureCardsData(index).cNum != '-' && getMeasureCardsData(index).cNum > 0" class="measure-card__count-divider">/</span>
							<span v-if="getMeasureCardsData(index).cNum && getMeasureCardsData(index).cNum != '-' && getMeasureCardsData(index).cNum > 0" class="measure-card__count-total">{{ getTestedNum() }}</span>
							<img v-if="getMeasureCardsData(index).cNum && getMeasureCardsData(index).cNum != '-' && getMeasureCardsData(index).cNum > 0" class="measure-card__header-arrow" src="../../../assets/icon_common_special_arrow_16.png" alt="查看箭头" />
						</div>
						
						<!-- 卡片内容区（老人列表） -->
						<div class="measure-card__content">
							<div v-if="!getMeasureCardsData(index).itemList" class="empty-state">
								<div class="empty-text">{{ '暂无数据' || ' ' }}</div>
							</div>
							<div class="measure-card__item" v-for="(item, idx) in getMeasureCardsData(index).itemList || []" :key="idx" @click="clickCardItem(item, idx, getMeasureCardsData(index).item)">
								<img class="measure-card__item-icon" src="../../../assets/icon_dean_home_card_measure_2.png" alt="老人图标" />
								<span class="measure-card__item-name">{{ item.bedName || '-' }}</span>
								<span class="measure-card__item-value" :class="item.itemStatus == 1 ? 'measure-card__item-value_wran' : ''">{{ item.itemValue || '-' }}</span>
								<span v-if="index == 2" class="measure-card__item-value">/</span>
								<span v-if="index == 2" class="measure-card__item-value"  :class="item.itemStatus2 == 1 ? 'measure-card__item-value_wran' : ''">{{ item.itemValue2 || '-' }}</span>
							</div>
						</div>
					</div>
				</div>
      </div>
    </div>
    
    <!-- 提示弹窗 -->
    <div class="tip-popup" v-if="isTip">
      <div class="tip-content">
        <div class="tip-text-container">
          <div class="tip-text-mask"></div>
          <div class="tip-text">
            ·黄区老人可以看情况筛选关心：根据对老人实际健康状态的了解程度，周期性合理的进行慢病跟踪（例如：呼吸急促的老人、频繁起夜的老人等）
          </div>
        </div>
        <div class="tip-actions">
          <div class="tip-meta">
            <span>2/3</span>
            <span class="skip-tip" @click="skippingTutorial">跳过教程</span>
          </div>
          <div class="next-btn" @click="next">下一步</div>
        </div>
      </div>
      <img class="tip-arrow" src="../../../assets/icon_home_hei_san_jiao_2.png" alt="" />
    </div>
    

		<HomeMeasureDialog 
			:dialog-visible.sync="isShowHomeMeasureDialog"
      :table-data="homeMeasureDialogTableData"
      :total="homeMeasureDialogTotal"
      @size-change="homeMeasureDialogHandlePageSizeChange"
      @current-change="homeMeasureDialogHandlePageChange"
		/>

		<HomeMeasuresDialog 
			:dialog-visible.sync="isShowHomeMeasuresDialog"
			:parentModel="currentCmdItem"
		/>

		<HomeMeasureSingleDialog 
			:dialog-visible.sync="isShowHomeMeasureSingleDialog"
			:currentHomeMeasureSingleDialogType="currentHomeMeasureSingleDialogType"
		/>
  </div>
</template>

<script>
import SecondCardAllAlert from './secondCardAllAlert.vue'; 
import WorkProposalAlert from './workProposalAlert.vue';
import portFn from '../../../utils/PortraitFunction.js';
import CustomRichText from '../../../utils/CustomRichText.js';
import HomeMeasureDialog from './HomeMeasureDialog.vue';
import HomeMeasureSingleDialog from './HomeMeasureSingleDialog.vue';
import HomeMeasuresDialog from './HomeMeasuresDialog.vue';

export default {
  components: {
    SecondCardAllAlert,
    WorkProposalAlert,
		HomeMeasureDialog,
		HomeMeasureSingleDialog,
		HomeMeasuresDialog
  },
  filters: {
    reMate(val) {
      return CustomRichText.reMateNew(portFn.function_reg_str_to_arr(val));
    }
  },
  props: {
    data: {
      type: Array,
      default: null
    },
    dataLength: {
      type: Number,
      default: 0
    },
    emptyString: {
      type: String,
      default: null
    },
    isTip: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      leftBtnState: 0,
      rightBtnState: 0,
      currentPage: 1,
			
			isShowHomeMeasureDialog: false,
			homeMeasureDialogTableData: [],
			homeMeasureDialogTotal: 0,

			isShowHomeMeasuresDialog: false,

			isShowHomeMeasureSingleDialog: false,
			currentHomeMeasureSingleDialogType: null,

			model: null,

			currentCmdItem: null
    };
  },
  async mounted() {
		this.getMeasureSituation();
  },
  methods: {

		// 获取当日测量情况
    getMeasureSituation(){
      this.$get(
        'api/measure/measureSituation',
        {},
        (res) => {
          if (res.code === 0) {
            if (res.data) {
							this.model = res.data;
						} else {
						}
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
		// 获取已测量、总测量
		getTestedNum() {
			let testedNum = this.$lodash.get(this.model, "testedNum", 0 ) !== null ? this.$lodash.get(this.model, "testedNum", 0 ) : 0;
			return testedNum;
		},
		getTotalNum() {
			let totalNum = this.$lodash.get(this.model, "totalNum", "-" ) !== null ? this.$lodash.get(this.model, "totalNum", "-" ) : '-';
			return totalNum;
		},
		// 获取测量四个卡片的数据
		getMeasureCardsData(index) {
			let data;
			if (index === 0) { // 血氧异常
				data = this.$lodash.get(this.model, "oxygenSaturationAbnormal", '-' ) !== null ? this.$lodash.get(this.model, "oxygenSaturationAbnormal", "-" ) : null;
			} else if (index === 1) { // 脉率异常
				data = this.$lodash.get(this.model, "pulseRateAbnormal", '-' ) !== null ? this.$lodash.get(this.model, "pulseRateAbnormal", "-" ) : null;
			} else if (index === 2) { // 血压异常
				data = this.$lodash.get(this.model, "bloodPressureAbnormal", '-' ) !== null ? this.$lodash.get(this.model, "bloodPressureAbnormal", "-" ) : null;
			} else { // 体温异常
				data = this.$lodash.get(this.model, "bodyTemperatureAbnormal", '-' ) !== null ? this.$lodash.get(this.model, "bodyTemperatureAbnormal", "-" ) : null;
			}
			
			let cardData = data ? JSON.parse(JSON.stringify(data)) : {}

			if (cardData) {
				if (index === 0) { // 血氧异常
					cardData.cIcon = require(`@/assets/icon_dean_home_card_measure_3.png`);
					cardData.cTitle = '血氧异常';
				} else if (index === 1) { // 脉率异常
					cardData.cIcon = require(`@/assets/icon_dean_home_card_measure_4.png`);
					cardData.cTitle = '脉率异常';
				} else if (index === 2) { // 血压异常
					cardData.cIcon = require(`@/assets/icon_dean_home_card_measure_5.png`);
					cardData.cTitle = '血压异常';
				} else { // 体温异常
					cardData.cIcon = require(`@/assets/icon_dean_home_card_measure_6.png`);
					cardData.cTitle = '体温异常';
				}
				cardData.cNum = cardData.abnormalNum

				if (cardData.itemList) {
					for (let i = 0; i < cardData.itemList.length; i++) {
						let tempItem = cardData.itemList[i];
						if (index === 0) { // 血氧异常
							tempItem.itemStatus = tempItem.oxygenSaturationAbnormal;
							tempItem.itemValue = tempItem.oxygenSaturation;
						} else if (index === 1) { // 脉率异常
							tempItem.itemStatus = tempItem.pulseRateAbnormal;
							tempItem.itemValue = tempItem.pulseRate;
						} else if (index === 2) { // 血压异常
							tempItem.itemStatus = tempItem.systolicBloodPressureAbnormal;
							tempItem.itemValue = tempItem.systolicBloodPressure;
							tempItem.itemStatus2 =  tempItem.diastolicBloodPressureAbnormal;
							tempItem.itemValue2 = tempItem.diastolicBloodPressure;
						} else { // 体温异常
							tempItem.itemStatus = tempItem.bodyTemperatureAbnormal;
							tempItem.itemValue = tempItem.bodyTemperature;
						}
					}
				}
				
			}
			return cardData;
		},

		async fetchTableData(page = 1, pageSize = 10) {
      // 实际项目中替换为真实接口请求
      const mockData = [
        {
          location: "E楼-8层-E803-陈洁珍",
          time: "08:08",
          spo2: "85",
          pulse: "78",
          bloodPressure: "110/90",
          temperature: "37",
        },
				{
          location: "E楼-8层-E803-陈洁珍",
          time: "08:08",
          spo2: "85",
          pulse: "78",
          bloodPressure: "110/90",
          temperature: "37",
        },
				{
          location: "E楼-8层-E803-陈洁珍",
          time: "08:08",
          spo2: "85",
          pulse: "78",
          bloodPressure: "110/90",
          temperature: "37",
        }
      ];
      this.homeMeasureDialogTableData = mockData;
      this.homeMeasureDialogTotal = 50; // 模拟总数据量为50条
    },

		// 处理每页条数变更（从弹窗组件传递过来的事件）
    homeMeasureDialogHandlePageSizeChange(pageSize) {
      console.log('每页条数变更为：', pageSize);
      // 重新请求数据（当前页重置为第1页）
      this.fetchTableData(1, pageSize);
    },

    // 处理页码变更（从弹窗组件传递过来的事件）
    homeMeasureDialogHandlePageChange(currentPage) {
      console.log('当前页码变更为：', currentPage);
      // 重新请求数据（使用当前页码和当前每页条数）
      this.fetchTableData(currentPage, this.pageSize);
    },

    // 查看全部
    seeAll() {
			this.isShowHomeMeasureDialog = true;
			return
      this.$refs.secondCardAllAlert.openAlert();
    },
    

		clickCard(item, index) {
			if (this.getTestedNum() === 0) {
				return
			}
			let type = index == 0 ? 'oxygenSaturation' : index == 1 ? 'pulseRate' : index == 2 ? 'bloodPressure' : 'bodyTemperature';
			this.currentHomeMeasureSingleDialogType = type;
			this.isShowHomeMeasureSingleDialog = true;
		},
		clickCardItem(item, idx, itemType) {
			let tempItem = item ? JSON.parse(JSON.stringify(item)) : {};
			tempItem.itemType = itemType;
			this.currentCmdItem = tempItem;
			console.log('=wawawawa', this.currentCmdItem)
			this.isShowHomeMeasuresDialog = true;
		}
  }
};
</script>

<style lang="scss" scoped>
// 先定义可复用变量（便于统一修改设计风格）
$measure-card-width: 310px;
$measure-card-height: 150px;
$measure-card-margin: 15px; // 卡片之间的间距
$measure-card-padding-x: 20px; // 卡片内部左右内边距
$measure-card-padding-top: 4px; // 标题栏顶部内边距
$measure-card-padding-content: 5px; // 内容区顶部间距

$color-text-normal: #5E6779; // 正常文本色
$color-text-warning: #FF7186; // 异常值文本色
$color-border-light: rgba(31, 38, 53, 0.05); // 浅色边框

$font-size-base: 14px; // 基础字体大小
$font-weight-normal: 400; // 正常字重
$font-weight-bold: 600; // 加粗字重
$line-height-base: 20px; // 基础行高

$icon-size-header: 20px; // 标题栏图标尺寸
$icon-size-item: 20px; // 列表项图标尺寸
$icon-size-arrow: 14px; // 箭头图标尺寸


.home_measure_card {
  height: 393px;
  position: relative;
  display: flex;
  margin: 30px 0;
  margin-left: 0px;

  .bg-img {
    width: 755px;
    height: 473px;
    &.static {
      position: relative;
      left: -40px;
      top: -40px;
    }
    &.absolute {
      position: absolute;
      left: -40px;
      top: -40px;
    }
  }

  .main-container {
    position: absolute;
    width: 675px;
    height: 393px;
  }

  .content-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
  }

  // 标题栏样式
  .header {
    display: flex;
    height: 39px;
    justify-content: space-between;
    align-items: flex-end;

    .title-group {
      display: flex;
      align-items: center;

      .title-tag {
        width: 5px;
        height: 20px;
        background: #4A7CE8;
        border-radius: 0 3px 3px 0;
      }

      .title-text {
        font-size: 18px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #1F2635;
        line-height: 24px;
        margin-left: 15px;
      }

      .count-badge {
        display: flex;
        align-items: center;
        margin-left: 5px;

        img {
          width: 7px;
          height: 8px;
          z-index: 1;
        }

        .count-text {
          margin-left: -2px;
          background: rgba(245, 247, 249, 1);
          border-radius: 4px;
          border: 1px solid rgba(229, 234, 238, 1);
          padding: 2px 5px;
          font-size: 14px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: rgba(94, 103, 121, 0.85);
          line-height: 20px;
        }
      }
    }

    .header-actions {
      display: flex;
      align-items: center;
      margin-bottom: 7px;

      img:first-child {
        width: 73px;
        height: 14px;
        margin-right: 10px;
      }

      .see-all {
        display: flex;
        align-items: center;
        margin-right: 20px;
        cursor: pointer;

        span {
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #4A7CE8;
          line-height: 22px;
          margin-right: 2px;
        }

        img:last-child {
          width: 16px;
          height: 16px;
        }
      }
    }
  }

  // 空状态样式
  .empty-state {
    width: 100%;
    height: 100%;
    // background: #ECF0F3;
    // box-shadow: inset 8px 8px 20px 0 #D1D9E6, inset -8px -8px 20px 0 #FFFFFF;
    border-radius: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    img {
      width: 107px;
      height: 107px;
      z-index: 1;
    }

    .empty-text {
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #A4ABB6;
      line-height: 20px;
    }
  }

  // 数据内容区主容器
	.data-content {
		display: flex;
		flex-wrap: wrap; // 自动换行（适配小屏幕）
		justify-content: center; // 水平居中
		align-items: center; // 垂直居中
		gap: $measure-card-margin; // 替代margin，均匀分配卡片间距
		flex: 1; // 占满父容器剩余高度
		padding: 20px $measure-card-padding-x; // 容器内边距，避免卡片贴边
		background: transparent; // 移除原红色背景（若为调试用）
		// 测量卡片容器（相对定位，用于背景图层级控制）
		.measure-card {
			position: relative; // 作为背景图和内容的定位容器
			width: $measure-card-width;
			height: $measure-card-height;
			display: flex;
			flex-direction: column;
			overflow: hidden; // 防止内容溢出卡片
		}

		// 卡片背景图（绝对定位，置于最下层）
		.measure-card__bg {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			z-index: 1; // 背景图层级最低
			object-fit: cover; // 确保背景图填满卡片且不变形
		}

		// 卡片标题栏（异常统计行）
		.measure-card__header {
			position: relative;
			z-index: 2; // 标题栏层级高于背景图
			display: flex;
			align-items: center;
			margin-top: $measure-card-padding-top;
			margin-left: $measure-card-padding-x;
			gap: 5px; // 元素之间间距统一
			font-size: $font-size-base;
			font-family: PingFangSC, PingFang SC;
			font-weight: $font-weight-normal;
			color: $color-text-normal;
			line-height: $line-height-base;
			cursor: pointer;
		}

		// 标题栏图标
		.measure-card__header-icon {
			width: $icon-size-header;
			height: $icon-size-header;
		}

		// 标题栏文本
		.measure-card__header-text {
			white-space: nowrap; // 防止文本换行
		}

		// 统计数字-正常部分
		.measure-card__count-normal {
			font-weight: $font-weight-bold;
			color: rgba(255, 113, 134, 1);
		}

		// 统计分隔符（/）
		.measure-card__count-divider {
			color: rgba(94, 103, 121, 1);
			font-weight: $font-weight-bold;
			margin-left: -5px;
		}

		// 统计数字-总数部分
		.measure-card__count-total {
			font-weight: $font-weight-bold;
			margin-left: -5px;
		}

		// 标题栏箭头图标
		.measure-card__header-arrow {
			width: $icon-size-arrow;
			height: $icon-size-arrow;
			margin-left: 0px; // 与数字保持小间距
		}

		// 卡片内容区（老人列表容器）
		.measure-card__content {
			position: relative;
			z-index: 2; // 内容区层级高于背景图
			display: flex;
			flex-direction: column;
			flex: 1; // 占满卡片剩余高度
			margin: $measure-card-padding-content $measure-card-padding-x 0; // 上下内边距
			gap: 2px; // 列表项之间微小间距
		}

		// 卡片列表项（单个老人信息）
		.measure-card__item {
			display: flex;
			align-items: center;
			height: 39px;
			border-bottom: 1px solid $color-border-light; // 底部浅色边框
			font-size: $font-size-base;
			font-family: PingFangSC, PingFang SC;
			line-height: $line-height-base;
			cursor: pointer;
			
			&:hover {
				.measure-card__item-name {
					color: rgb(74, 124, 232); // 悬停时文字变为蓝色
				}
			}
		}

		// 列表项图标（老人头像占位）
		.measure-card__item-icon {
			width: $icon-size-item;
			height: $icon-size-item;
			margin-right: 5px; // 与姓名保持间距
		}

		// 列表项-老人姓名
		.measure-card__item-name {
			flex: 1; // 姓名占满中间空间（挤压数值到右侧）
			color: $color-text-normal;
			font-weight: $font-weight-normal;
			white-space: nowrap; // 防止姓名换行
			overflow: hidden; // 超出部分隐藏
			text-overflow: ellipsis; // 超出部分显示省略号
			transition: color 0.2s ease; // 可选：添加颜色过渡动画，使效果更平滑
		}

		// 列表项-血氧数值（异常色）
		.measure-card__item-value {
			color: $color-text-normal;
			font-weight: $font-weight-normal;
			white-space: nowrap; // 防止数值换行
		}

		.measure-card__item-value_wran {
			color: $color-text-warning;
			font-weight: $font-weight-normal;
			white-space: nowrap; // 防止数值换行
		}
	}

  // 提示弹窗样式
  .tip-popup {
    position: absolute;
    top: -200px;
    left: 336px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .tip-content {
      width: 529px;
      background: #5E6779;
      border-radius: 8px;
      padding: 20px 20px 15px;

      .tip-text-container {
        background: rgba(255, 255, 255, 0.1);
        border-radius: 6px;
        padding: 10px 15px;
        position: relative;

        .tip-text-mask {
          position: absolute;
          height: 8px;
          background: rgba(243, 183, 61, 0.3);
          left: 120px;
          top: 25px;
          width: 110px;
          &::after {
            content: '';
            position: absolute;
            height: 8px;
            background: rgba(243, 183, 61, 0.3);
            left: 200px;
            top: 24px;
            width: 63px;
          }
          &::before {
            content: '';
            position: absolute;
            height: 8px;
            background: rgba(243, 183, 61, 0.3);
            left: 327px;
            top: 24px;
            width: 16px;
          }
        }

        .tip-text {
          font-family: PingFangSC, PingFang SC;
          font-weight: 200;
          font-size: 16px;
          color: #FFFFFF;
          line-height: 24px;
          position: relative;
          z-index: 1;
        }
      }

      .tip-actions {
        margin-top: 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .tip-meta {
          display: flex;

          span {
            font-family: PingFangSC, PingFang SC;
            font-weight: 200;
            font-size: 14px;
            color: rgba(255, 255, 255, 0.5);
            line-height: 24px;
          }

          .skip-tip {
            margin-left: 15px;
            cursor: pointer;
          }
        }

        .next-btn {
          width: 72px;
          height: 30px;
          background: #4A7CE8;
          border-radius: 20px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 14px;
          color: #FFFFFF;
          line-height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }
      }
    }

    .tip-arrow {
      width: 38px;
      height: 12px;
    }
  }

  // 富文本样式
  ::v-deep .richTextDiv {
    .richContentStyle {
      display: flex;
    }
    .richTextStyleNormal {
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #5E6779;
      line-height: 20px;
    }
    .richTextStyleRed {
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: rgba(255, 113, 134, 1);
      line-height: 20px;
    }
  }

	.empty-state-1 {
		position: absolute;
		background: red;
    background: #ECF0F3;
		left: 20px;
		top: 60px;
		width: 635px;
		height: 318px;
    box-shadow: inset 8px 8px 20px 0 #D1D9E6, inset -8px -8px 20px 0 #FFFFFF;
    border-radius: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    img {
      width: 107px;
      height: 107px;
      z-index: 1;
    }

    .empty-text {
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #A4ABB6;
      line-height: 20px;
      margin-top: 15px;
    }
  }
}
</style>








